import { IFormArr } from '@/components/types'

export const basicFormConfig: IFormArr = {
  iForms: [
    {
      formItems: [
        {
          label: '客户Id',
          field: 'customerId',
          type: 'input',
          maxLength: 10,
          placeholder: '客户Id',
          isDisabled: true
        },
        {
          label: '客户姓名',
          field: 'customerName',
          type: 'input',
          maxLength: 10,
          placeholder: '请输入客户姓名'
        },
        {
          label: '客户昵称',
          field: 'custNickName',
          type: 'input',
          maxLength: 50,
          placeholder: '请输入客户昵称',
          isDisabled: true
        }
      ]
    },
    {
      formItems: [
        {
          label: '开发账号',
          field: 'exploitAccount',
          type: 'input',
          maxLength: 50,
          placeholder: '请输入开发账号',
          isDisabled: true
        },
        {
          label: '资金量',
          type: 'select',
          field: 'funds',
          placeholder: '请选择资金量',
          options: [
            { title: '<5万', value: '0' },
            { title: '5-10万', value: '1' },
            { title: '≥10万', value: '2' }
          ]
        },
        {
          label: '资源承接日期',
          field: 'undertakeDate',
          type: 'datepicker',
          otherOptions: {
            placeholder: '选择资源承接日期',
            type: 'datetime',
            'value-format': 'YYYY-MM-DD HH:mm:ss'
          },
          isDisabled: true
        }
      ]
    },
    {
      formItems: [
        {
          label: '资金证明图',
          field: 'proofImgUrls',
          type: 'slot'
        },
        {
          label: '备注',
          field: 'remark',
          type: 'textarea',
          maxLength: 300,
          placeholder: '请输入备注',
          rows: 2
        }
      ]
    },
    {
      formItems: [
        {
          label: '部门',
          field: 'deptName',
          type: 'default',
          isHidden: true
        },
        {
          label: '员工',
          field: 'empName',
          type: 'default',
          isHidden: true
        },
        {
          label: '填报日期',
          field: 'fillDate',
          type: 'default',
          isHidden: true
        }
      ]
    }
  ]
}
